<template>
  <div class="wmsView">
    <div class="wmsT">
        <img class="image" src="./img/title.png" alt="">
    </div>
    <div class="caption">
        <img class="image" src="./img/caption.png" alt="">
    </div>
    <div class="explain wmsTitle">
        <img class="image" src="./img/explain.png" alt="">
    </div>
    <div class="explain wmsTitle">
        <img class="image" src="./img/explainA.png" alt="">
    </div>
    <div class="explain wmsTitle">
        <img class="image" src="./img/explainB.png" alt="">
    </div>
    <div class="explain wmsTitle">
        <img class="image" src="./img/explainC.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'wmsView'

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.wmsTitle{
   padding-left: 26px;
   padding-right: 26px;
}
.caption{
    width: 250px;
    height: 107px;
    margin: 50px auto;
}
.explain{
    margin-bottom: 24px;
}
.image{
    width:100%;
    height: 100%;
}
</style>
